import {SVG} from '@eCommerce/frontend-legacy-shared-library';
import {View} from 'native-base';
import React from 'react';

import LoadingSpinner from 'components/LoadingSpinner';
import ConnectedPRHeader from 'containers/ConnectedPRHeader';
import {useIsMD} from 'hooks/useIsMD';
import {useIsOpenWebView} from 'hooks/useIsOpenWebView';

import PRFooter from '../PRFooter';
import {PRTitle} from '../PRLabels';
import PRWarningBanner from '../PRWarningBanner';

interface WarningProps {
  label: string;
  testID: string;
}

export interface PRPageTemplateProps {
  children?: React.ReactElement;
  footerCTALabel: string;
  footerOnPress: () => void;
  footerButtonDisabled?: boolean;
  title?: string;
  loading?: boolean;
  testID: string;
  warning?: WarningProps;
}

const TOP_WAVES_URL =
  'https://www.caesars.com/content/dam/empire/loaders/patterns/waves-top-white.svg';

const CAESARS_REWARDS_LOGO_DARK =
  'https://www.caesars.com/content/dam/empire/logos/navigation-logos/caesars_rewards_logo_y.svg';

const PRPageTemplate: React.FC<PRPageTemplateProps> = (props) => {
  const {
    children,
    footerCTALabel,
    footerOnPress,
    footerButtonDisabled,
    title,
    loading,
    testID,
    warning,
  } = props;
  const isMD = useIsMD();
  const hideHeaderClose = useIsOpenWebView();

  return (
    <View
      alignItems="center"
      justifyContent={isMD ? 'center' : undefined}
      minH={isMD ? '100vh' : undefined}
      w={isMD ? '100%' : undefined}
      bgColor="#F7F7F8"
      testID={testID}
    >
      <View
        h={isMD ? '800px' : '100dvh'}
        w={isMD ? '768px' : '100vw'}
        backgroundColor="white"
        style={
          isMD
            ? {
                shadowColor: '#000',
                shadowOffset: {
                  width: 0,
                  height: 4,
                },
                shadowOpacity: 0.1,
                shadowRadius: 6.0,
              }
            : undefined
        }
        zIndex={1}
      >
        <SVG
          source={TOP_WAVES_URL}
          style={{position: 'absolute', top: 0, left: 0, zIndex: 1}}
          width={233}
          height={238}
          alt="Caesars Rewards logo"
        />
        {hideHeaderClose ? (
          <View h={isMD ? '30px' : '80px'} width="100%" />
        ) : (
          <ConnectedPRHeader testID={testID} />
        )}
        <View
          alignItems="center"
          flex={1}
          p={isMD ? '64px' : undefined}
          zIndex={2}
        >
          <View alignItems="center" zIndex={9} style={{zIndex: 9}}>
            <SVG
              source={CAESARS_REWARDS_LOGO_DARK}
              height={80}
              alt="Caesars Rewards Logo"
              style={{zIndex: 9}}
            />
          </View>
          {warning ? (
            <View px="16px" pt="14px" pb="16px" width="100%" maxW="390px">
              <PRWarningBanner label={warning.label} testID={warning.testID} />
            </View>
          ) : null}
          <View
            px="16px"
            pt={warning ? undefined : '80px'}
            maxW="390px"
            flexDirection="column"
            flex={isMD ? undefined : 1}
            justifyContent={isMD ? undefined : 'space-between'}
            backgroundColor={loading ? '#ffffff' : undefined}
          >
            {title ? <PRTitle testID={testID}>{title}</PRTitle> : null}
            {children}
            <View mt={3} minHeight="48px" justifyContent="center" flex={1}>
              {loading ? <LoadingSpinner /> : null}
            </View>
            <PRFooter
              CTALabel={footerCTALabel}
              onPress={footerOnPress}
              buttonDisabled={footerButtonDisabled}
              testID={testID}
            />
          </View>
        </View>
      </View>
    </View>
  );
};

export default PRPageTemplate;
